import { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Container, Grid, Paper, Typography } from "@mui/material";

import { useHistory, useParams } from "react-router-dom";
import { emailVerification } from "../../controllers/AuthController";

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmarkCircle } from "@fortawesome/free-solid-svg-icons";

export default function EmailVerification()
{
    const [isLoading,setIsLoading] = useState(true);

    const [title,setTitle] = useState('');
    const [msg,setMsg] = useState('');
    const [success,setSuccess] = useState(false);
    const [isOpen,setIsOpen] = useState(false);
    
    const { email, code } = useParams();

    const history = useHistory();

    useEffect(()=>{
        hanldeEmailVerification();
    },[]);

    const redirect = (route) => {
        history.push(route)
    }

    const hanldeEmailVerification = async () => {
        setIsLoading(true);
        let response = await emailVerification(email,code);
        console.log(response.message);
        if(response.success === true)
        {
            setSuccess(true);
            setTitle('Operación Exitosa!');
            setMsg(response.message);
            setIsOpen(true);
        }
        else if(response.success === false)
        {
            setSuccess(false);
            setTitle('Operación Fallida!');
            setMsg(response.message);
            setIsOpen(true);
        }
        else
        {
            setSuccess(false);
            setTitle('Operación Fallida!');
            setMsg('En estos momentos su solicitidud no puede ser procesada!');
            setIsOpen(true);
        }

        setIsLoading(false);
    }

    return(
        <Container maxWidth='lg'>
            <Grid height='100vh' container spacing={3} justifyContent='center' alignItems='center'>
                {
                    isLoading &&
                    <CircularProgress/>
                }
                {
                    isOpen &&
                    <Grid item xs={12} sm={10} md={6} lg={6} xl={6}>
                        <Paper elevation={4}
                            sx={{
                                borderWidth:1,
                                border:'solid',
                                borderColor: success?'success.light':'error.light'
                            }}
                        >
                            <Box sx={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
                                {
                                    success === true
                                    ?<CheckCircleOutlineIcon sx={{fontSize:70,color:'success.light'}}/>
                                    :<FontAwesomeIcon size="3x" icon={faXmarkCircle} color="red"/>
                                    
                                }
                                
                            </Box>
                            <Typography variant="h6" fontWeight='bold' textAlign='center'>{title}</Typography>
                            <br/>
                            <Typography variant="h6" textAlign='center'>{msg}</Typography>
                            <br/>
                            {
                                success &&
                                <Grid container spacing={3} justifyContent='center'>
                                    <Grid item lg={6} xl={6}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="success"
                                            onClick={()=> redirect('/auth/signIn') }
                                        >
                                            Iniciar sesion
                                        </Button>
                                    </Grid>
                                </Grid>
                            }
                            
                        </Paper>
                    </Grid>
                }
            </Grid>
        </Container>
    )
    
}